module.exports = __webpack_public_path__ + "img/logo-zh.48f9beeb.png";